/**
 * Created by daniel on 27/04/17.
 */

import React, {Component} from 'react';
import DropZoneFrame from "./DropZoneFrame";
import {getUiDraggedItem, getUiDropzoneCoords} from "../../state/ui/selectors";
import {connect} from "react-redux";

class DropZoneFrameContainer extends Component {
  render() {
    return (
      this.props.coords && <DropZoneFrame coords={this.props.coords}/>
    );
  }
}

function mapStateToProps(state) {
  let item = getUiDraggedItem(state);
  let coords = getUiDropzoneCoords(state);
  
  return {
    item,
    coords,
  }
}

export default connect(mapStateToProps)(DropZoneFrameContainer);


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/DropZoneFrameContainer.js